/**
 * We need this variable because in Gecko-UI, the header accepts a height and uses that to set its internal
 * --header-height css variable; however, the PageLayout component has its own --header-height css variable that is
 * hard-coded (to 5rem), and that is what ends up getting inherited by our components (because they are children of
 * PageLayout, but not the Header).
 */
export const HEADER_HEIGHT = '4rem'
